<template>
  <v-card :id="getElIdSelector().replace('#', '')" v-scroll:[getElIdSelector()]="onScroll" class="scroll-y" :height=internalHeight :flat="flat" v-resize="onResize">
    <v-container v-if="!md" px-2 pt-2
    fluid
    grid-list-lg
    :style="style"
    ref="slot"
    >
      <slot></slot>
    </v-container>
    <v-container v-if="md" px-1
    fluid
    grid-list-md
    :style="style"
    ref="slot"
    >
      <slot></slot>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: 'v-card-scroll',
    components: {},
    data: () => ({
      internalHeight: null
    }),
    props: {
      height: {
        type: String,
        default: null
      },
      offset: {
        // additional offset, in case automatic calculation
        type: String,
        default: '0'
      },
      up: {
        type: Boolean,
        default: false
      },
      md: {
        type: Boolean,
        default: false
      },
      flat: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      const cb = () => {
        this.onResize()
      }
      this.waitSlotMounted(cb)
    },
    computed: {
      style () {
        // define min-height more than size for turning on scrolling
        return `min-height: ${this.internalHeight}; margin-top: 1px`
      }
    },
    methods: {
      getElIdSelector () {
        return '#scroll_target_' + this._uid
      },
      waitSlotMounted (cb) {
        let i = 0
        const wait = () => {
          setTimeout(() => {
            // console.log('waitChildren', i)
            // TODO - if slot is empty infinite wait
            if (this.$refs.slot && this.$refs.slot.clientHeight > 0 || i >= 100) {
              cb()
            } else {
              i++
              wait()
            }
          }, 100)
        }
        wait()
      },
      onResize () {
        if (this.height) {
          this.internalHeight = this.height
          return
        }
        let offsetTop = 0
        let l = this.$el
        while (l) {
          offsetTop = offsetTop + l.offsetTop
          l = l.offsetParent
        }
        console.log('onResize1', offsetTop, this.offset)
        this.internalHeight = window.innerHeight - offsetTop - parseInt(this.offset, 10) + 'px'
      },
      onScroll (e) {
        var limit = e.target.scrollHeight > (10 * e.target.clientHeight) ? 10 * e.target.clientHeight : 2 * e.target.clientHeight
        // console.log('onScroll', limit, e.target.scrollTop, e.target.scrollHeight)
        if (limit > 0) {
          if ((!this.up && e.target.scrollTop > e.target.scrollHeight - limit) ||
            (this.up && e.target.scrollTop < limit)) {
            this.$emit('nextPage', e)
          }
        }
      },
      scrollTo (classCss) {
        let el = document.querySelector(`${this.getElIdSelector()} ${classCss}`)
        if (el) {
          el.scrollIntoView(true)
        }
      },
      scrollToListActive () {
        this.scrollTo('.v-list__tile--active')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// CardScroll.vue?39443bb7